import styled from "styled-components";

const ACTIVE_SECTION_COLOR = '#CC214F';
const ACTIVE_SECTION_COLOR_SHADOW = 'rgba(204, 33, 79, 0.35)';
const DISABLED_BUTTON_COLOR = '#908B8B';
const NOTICE_COLOR = '#E8A838';

export const CardRoot = styled.article<{$isDimmed?: boolean; $isCurrent?: boolean}>`
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
    background-color: ${(props) => props.theme.palette.contractElementPanel};
    border-radius: 12px;
    border: 2px solid ${(props) => props.$isCurrent ? ACTIVE_SECTION_COLOR_SHADOW : 'transparent'};
    box-shadow: ${(props) => props.$isCurrent
        ? `2px 2px 2px 1px ${ACTIVE_SECTION_COLOR_SHADOW}`
        : '2px 2px 2px 1px rgba(0, 0, 0, 0.2)'};
    opacity: ${(props) => props.$isDimmed ? 0.55 : 1};
    overflow: hidden;
    cursor: default;

    & + &
    {
        margin-top: 1em;
    }
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    min-width: 0;
`;

export const CardTitle = styled.h3`
    margin: 0;
    min-width: 0;
    flex: 1 1 auto;
    font-size: 18px;
    font-weight: 900;
    line-height: 1.3;
    text-align: left;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const CardBadge = styled.span`
    flex: 0 0 auto;
    max-width: 40%;
    box-sizing: border-box;
    background-color: ${(props) => props.theme.palette.bubbleMapConfiguration};
    border-radius: 12px;
    text-align: center;
    padding: 4px 10px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 0;
`;

export const CardDescription = styled.p`
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const CardNotice = styled.p`
    margin: 0;
    padding: 0.5rem 0.75rem;
    border-left: 4px solid ${NOTICE_COLOR};
    border-radius: 8px;
    background-color: rgba(232, 168, 56, 0.12);
    font-size: 15px;
    font-weight: 600;
    line-height: 1.4;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const TaskList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    min-width: 0;
    margin-top: 0.25rem;
`;

export const TaskRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    min-width: 0;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
`;

export const TaskContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1 auto;
    min-width: 0;
`;

export const TaskActionButton = styled.button<{ $isDisabled?: boolean }>`
    box-sizing: border-box;
    flex: 0 0 auto;
    margin-left: auto;
    align-self: center;
    background-color: ${(props) => props.$isDisabled ? DISABLED_BUTTON_COLOR : ACTIVE_SECTION_COLOR};
    color: white;
    border: 1px solid white;
    border-radius: 12px;
    padding: 8px 1.3em;
    cursor: ${(props) => props.$isDisabled ? 'default' : 'pointer'};
    font-size: 14px;
    line-height: 1.2;
    white-space: nowrap;
    text-align: center;

    &:disabled
    {
        cursor: default;
    }
`;

export const TaskTitle = styled.h4`
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const TaskDescription = styled.p`
    margin: 0;
    font-size: 15px;
    line-height: 1.4;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const CardFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: auto;
    padding-top: 1rem;
    min-width: 0;
`;

export const GuideButton = styled.button`
    box-sizing: border-box;
    min-width: 0;
    max-width: 100%;
    flex: 0 1 auto;
    margin-right: auto;
    background-color: transparent;
    color: ${ACTIVE_SECTION_COLOR};
    border: 1px solid ${ACTIVE_SECTION_COLOR};
    border-radius: 12px;
    padding: 8px 1em;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.2;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    text-align: center;
`;

export const ActionButton = styled.button<{ $isDisabled?: boolean }>`
    box-sizing: border-box;
    min-width: 0;
    max-width: 100%;
    flex: 0 1 auto;
    background-color: ${(props) => props.$isDisabled ? DISABLED_BUTTON_COLOR : ACTIVE_SECTION_COLOR};
    color: white;
    border: 1px solid white;
    border-radius: 12px;
    padding: 8px 1.3em;
    cursor: ${(props) => props.$isDisabled ? 'default' : 'pointer'};
    font-size: 14px;
    line-height: 1.2;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    text-align: center;

    &:disabled
    {
        cursor: default;
    }
`;